import styles from "./Navbar.module.scss";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/features/auth/authSlice";
import { FaUserCircle } from "react-icons/fa";
import { NavLink } from "react-router-dom";

const activeLink = ({ isActive }) => (isActive ? `${styles.active}` : "");

const Navbar = () => {
  const user = useSelector(selectUser);
  const userName = user?.name;
  return (
    <div className={styles.navbar}>
      <div className={styles.user}>
        {/* <FaUserCircle size={40} color="#fff" /> */}
        <img
          src={user.photo}
          alt="profileImage"
          style={{ borderRadius: "50px", width: "100px" }}
        />
        <h4>{userName}</h4>
      </div>
      <nav>
        <ul>
          <li>
            <NavLink to={"/admin/home"} className={activeLink}>
              Home
            </NavLink>
          </li>

          <li>
            <NavLink to={"/admin/all-posts"} className={activeLink}>
              All Posts
            </NavLink>
          </li>
          <li>
            <NavLink to={"/admin/add-post"} className={activeLink}>
              Add Post
            </NavLink>
          </li>
          <li>
            <NavLink to={"/admin/all-votes"} className={activeLink}>
              All Votes
            </NavLink>
          </li>
          <li>
            <NavLink to={"/admin/add-vote"} className={activeLink}>
              Add vote
            </NavLink>
          </li>
          <li>
            <NavLink to={"/admin/all-adds"} className={activeLink}>
              All Adds
            </NavLink>
          </li>
          <li>
            <NavLink to={"/admin/add-adds"} className={activeLink}>
              Add Adds
            </NavLink>
          </li>
          {/* <li>
            <NavLink to={"/admin/orders"} className={activeLink}>
              Orders
            </NavLink>
          </li> */}
          {/* <li>
            <NavLink to={"/admin/coupon"} className={activeLink}>
              Coupon
            </NavLink>
          </li> */}
          <li>
            <NavLink to={"/admin/category"} className={activeLink}>
              Categories
            </NavLink>
          </li>
          <li>
            <NavLink to={"/admin/brand"} className={activeLink}>
              Types
            </NavLink>
          </li>
          <li>
            <NavLink to={"/admin/view-users"} className={activeLink}>
              Users
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};
export default Navbar;
